import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { CcSectionsComponent } from "@app/cc-sections/cc-sections.component"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Google2faQrCodeComponent } from "@app/google2fa-qr-code/google2fa-qr-code.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-cc-params-security",
	imports: [
		COMMON_IMPORTS,
		CcSectionsComponent,
		LangValPipe,
		GenInputComponent,
		ModalWrapComponent,
		Google2faQrCodeComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-cc-sections
			name="security"
			section="security"
		/>
		<div class="container-wrap">
			<hr class="separation-line" />

			<div>
				<div class="row">
					<div class="col-6 col-md-2 ">
						<label>{{ "time_to_logout" | langVal }}</label>
						<app-gen-input
							tabindex="63"
							[actualObj]="configcliniq"
							[errors]="errors"
							fieldName="time_to_logout"
							(keyupEvent)="validateAndSave()"
						/>
					</div>
				</div>
				@if (!permsService.owner_has_users) {
					<div class="row">
						<!--						<div class="col-12 col-lg-2 ">-->
						<!--							<label>{{ "is_google2fa" | langVal }}</label>-->
						<!--							<app-gen-button-group-->
						<!--								[actualObj]="configcliniq"-->
						<!--								fieldName="is_google2fa"-->
						<!--								optionsListName="yes_no_opts"-->
						<!--								(changeEvent)="validateAndSave()"-->
						<!--							/>-->
						<!--						</div>-->
						<div class="action-buttons p-0 col-12 col-lg-2 ">
							<button
								class="btn btn-primary modal-btns"
								(click)="is2faOpen = true"
							>
								<!--preIcon="changePassword"-->
								{{ "get_2fa_key" | langVal }}
							</button>
						</div>
					</div>
				}
			</div>
		</div>

		@if (is2faOpen) {
			<app-modal-wrap
				(onClose)="is2faOpen = false"
				hasExit
				title="get_2fa_key"
				modalWrapperClass="modal-default-width"
			>
				<app-google2fa-qr-code (onClose)="is2faOpen = false" />
			</app-modal-wrap>
		}
	`,
})
export class CcParamsSecurityComponent extends CcParamsGen {
	is2faOpen: boolean = false
	saveObjName: string = "security" //which part to save while updating
}
